// French for the Acceptance tab: the ladder, the move, the readiness ledger, the plan, the defect
// board, the acceptance records and every confirm. Registered on load.
import { registerFr } from '../i18n/index.js';

registerFr({
  // ── masthead / shell ─────────────────────────────────────────────────────
  'Acceptance': 'Acceptation',
  'no engagement selected': 'aucun mandat sélectionné',
  'UAT and acceptance are always scoped to one engagement': 'Les UAT et l’acceptation portent toujours sur un seul mandat',
  'A test plan belongs to one register and one client portal. Pick an engagement in the top bar and its instrument loads here.':
    'Un plan de test appartient à un seul registre et à un seul portail client. Choisissez un mandat dans la barre supérieure ; son instrument se charge ici.',
  'The acceptance instrument could not be read': 'L’instrument d’acceptation n’a pas pu être lu',
  'GET /api/acceptance/state did not answer.': 'GET /api/acceptance/state n’a pas répondu.',
  'The acceptance instrument': 'L’instrument d’acceptation',
  'review window': 'délai de vérification',
  'working days': 'jours ouvrables',
  'working days.': 'jours ouvrables.',
  'Preview as client': 'Aperçu côté client',

  // ── the ladder ───────────────────────────────────────────────────────────
  'Everything on this tab is discharged.': 'Tout sur cet onglet est acquitté.',
  'Step {n} of {total}.': 'Étape {n} sur {total}.',
  'The two gates this tab clears:': 'Les deux gates que cet onglet libère :',
  'of': 'sur',
  'the gate engine did not answer': 'le moteur de gates n’a pas répondu',
  'First unmet — {label}: {detail}.': 'Première condition non remplie — {label} : {detail}.',
  'Lifecycle →': 'Cycle de vie →',

  // ── the move ─────────────────────────────────────────────────────────────
  'Next move': 'Prochain coup',
  '{n} other thing standing on this tab': '{n} autre point en suspens sur cet onglet',
  '{n} other things standing on this tab': '{n} autres points en suspens sur cet onglet',
  'Ready the plan': 'Rendre le plan disponible',
  'names every write, and every condition it will not touch, before it makes any':
    'nomme chaque écriture, et chaque condition qui restera intacte, avant d’en effectuer la moindre',
  'Issue the deemed-acceptance notice': 'Émettre l’avis d’acceptation tacite',
  'Read the record first': 'Lire d’abord le procès-verbal',
  "from the scheduler's task on": 'depuis la tâche du Scheduler sur',
  'raised‖ago': 'créée il y a',
  'days ago': 'jours',
  'Move {ref} to {state}': 'Faire passer {ref} à {state}',
  'Open the board': 'Ouvrir le tableau',
  'Compose a record': 'Établir un procès-verbal',
  'Write the test cases →': 'Rédiger les cas de test →',
  "the Register's test-case tab, where a criterion becomes something a person can run":
    'l’onglet «cas de test» du registre, où un critère devient quelque chose qu’une personne peut exécuter',
  'See the plan': 'Voir le plan',
  'Open the record': 'Ouvrir le procès-verbal',

  // ── zones ────────────────────────────────────────────────────────────────
  'The plan': 'Le plan',
  'Defects': 'Défauts',
  'The record': 'Le procès-verbal',

  // ── readiness ledger ─────────────────────────────────────────────────────
  'The plan is reachable —': 'Le plan est accessible —',
  'test cases, published and live for {client}.': 'cas de test, publiés et actifs pour {client}.',
  'Portal on': 'Portail actif',
  'invited': 'invités',
  'matrix open on test cases, criteria and defects.': 'matrice ouverte sur les cas de test, les critères et les défauts.',
  'Before the client can run this': 'Avant que le client puisse l’exécuter',
  'conditions unmet': 'conditions non remplies',
  'not applicable': 'non applicable',
  'clear': 'remplie',
  'The same control as the card above — one confirm,': 'Le même contrôle que la carte ci-dessus — une confirmation,',
  'writes, no page changes. The portal switch and the linter row are not in it: who may see this engagement, and whether a criterion is testable at all, are judgements, not flags a batch can flip.':
    'écritures, aucun changement de page. Le commutateur du portail et la ligne du linter n’en font pas partie : qui peut voir ce mandat, et si un critère est testable ou non, relèvent de jugements, pas d’indicateurs qu’un lot peut faire basculer.',

  // ── the plan ─────────────────────────────────────────────────────────────
  'test cases': 'cas de test',
  'runnable': 'exécutables',
  'run‖done': 'exécuté',
  'pass': 'réussi',
  'fail': 'échoué',
  'blocked': 'bloqué',
  'not run': 'non exécuté',
  'NOT RUN': 'NON EXÉCUTÉ',
  'Everything in the engagement': 'Tout le mandat',
  '{n} deliverable': '{n} livrable',
  '{n} deliverables': '{n} livrables',
  'This milestone carries no deliverables': 'Ce jalon ne porte aucun livrable',
  '“{name}” has nothing mapped to it, so there is nothing to test': '«{name}» n’a rien qui lui soit rattaché, donc il n’y a rien à tester',
  'under this filter': 'sous ce filtre',
  '. The engagement has': '. Le mandat compte',
  'elsewhere and': 'ailleurs et',
  '{n} recorded run': '{n} exécution de test enregistrée',
  '{n} recorded runs': '{n} exécutions de test enregistrées',
  '— the filter is hiding them, not the register.': '— le filtre les masque, pas le registre.',
  'This milestone': 'Ce jalon',
  'Show everything in the engagement': 'Afficher tout le mandat',
  'Nothing to test yet': 'Rien à tester pour l’instant',
  'A plan needs a deliverable, a requirement mapped to it, an acceptance criterion on that requirement and a test case against the criterion. This engagement has':
    'Un plan a besoin d’un livrable, d’une exigence qui lui est rattachée, d’un critère d’acceptation sur cette exigence et d’un cas de test pour ce critère. Ce mandat compte',
  'acceptance criteria and': 'critères d’acceptation et',
  'test cases on record.': 'cas de test enregistrés.',
  'Open the Register →': 'Ouvrir le registre →',
  'published': 'publié',
  'unpublished': 'non publié',
  'planned': 'planifié',
  'in_progress': 'en cours',
  'delivered': 'livré',
  'accepted': 'accepté',
  'dropped': 'abandonné',
  'None of these criteria is reachable by {client} — the reasons are the': 'Aucun de ces critères n’est accessible pour {client} — les raisons en sont les',
  'conditions above, not anything on these rows.': 'conditions ci-dessus, rien sur ces lignes.',
  'No test case exists on this engagement at all, so there is nothing for the client to press pass or fail on.':
    'Aucun cas de test n’existe sur ce mandat, donc il n’y a rien sur quoi le client puisse cliquer «réussi» ou «échoué».',
  'Read them here as the register, not as a plan that is live.': 'Lisez-les ici comme le registre, non comme un plan actif.',
  'No requirement is mapped to this deliverable — unjustified work.': 'Aucune exigence n’est rattachée à ce livrable — travail non justifié.',
  'No acceptance criterion — nothing to test, and nothing a defect could cite.': 'Aucun critère d’acceptation — rien à tester, et rien qu’un défaut pourrait citer.',
  'no test': 'aucun test',
  'draft': 'brouillon',
  'criterion hidden': 'critère masqué',
  '— nothing recorded': '— rien d’enregistré',
  'Raise defect': 'Signaler un défaut',
  'Record a run': 'Enregistrer une exécution',

  // ── recorded runs ────────────────────────────────────────────────────────
  'Recorded runs': 'Exécutions enregistrées',
  'recorded': 'enregistré',
  'latest': 'dernière',
  'nothing recorded': 'rien d’enregistré',
  'No result has been recorded': 'Aucun résultat n’a été enregistré',
  'Results land here the moment the client records them in the portal — or the moment you record one yourself from a witnessed session, using the control on each criterion above.':
    'Les résultats apparaissent ici dès que le client les enregistre dans le portail — ou dès que vous en enregistrez un vous-même lors d’une session observée, via le contrôle sur chaque critère ci-dessus.',
  'Results land here the moment the client records them in the portal — or the moment you record one yourself from a witnessed session. Right now neither can happen: the plan is not reachable, so the portal shows the client nothing to run.':
    'Les résultats apparaissent ici dès que le client les enregistre dans le portail — ou dès que vous en enregistrez un vous-même lors d’une session observée. Pour l’instant, ni l’un ni l’autre n’est possible : le plan n’est pas accessible, le portail ne montre donc rien à exécuter au client.',
  'Back to step 1': 'Retour à l’étape 1',
  'Test': 'Test',
  'Note the tester left': 'Note laissée par le testeur',
  'Result': 'Résultat',
  'By': 'Par',
  'When': 'Quand',
  'Evidence': 'Preuves',
  'portal': 'portail',
  'operator': 'opérateur',
  'attachment': 'pièce jointe',

  // ── defect board ─────────────────────────────────────────────────────────
  'Defect board': 'Tableau des défauts',
  'open': 'ouvert',
  'blocking or major': 'bloquant ou majeur',
  'oldest': 'le plus ancien depuis',
  'days': 'jours',
  'nothing raised': 'rien de signalé',
  'No defect has been raised': 'Aucun défaut n’a été signalé',
  'A defect must cite the acceptance criterion it violates — that constraint is in the schema, not the form. If nothing agreed was broken, the honest instrument is a change request.':
    'Un défaut doit citer le critère d’acceptation qu’il viole — cette contrainte est dans le schéma, pas dans le formulaire. Si rien de convenu n’a été rompu, l’instrument honnête est une demande de modification.',
  'Right now the client cannot raise one either:': 'Pour l’instant, le client ne peut pas non plus en signaler un :',
  'criteria are unpublished, so their form has nothing to select.': 'critères sont non publiés, leur formulaire n’a donc rien à sélectionner.',
  'Open the plan to raise one from a failing run': 'Ouvrir le plan pour en signaler un depuis une exécution en échec',
  'Severity definitions —': 'Définitions de gravité —',
  ', the wording that goes in the record': ', le texte qui figure dans le procès-verbal',
  'blocking': 'bloquant',
  'major': 'majeur',
  'minor': 'mineur',
  'in fix': 'en correction',
  'fixed': 'corrigé',
  'verified': 'vérifié',
  'closed': 'clos',
  'withdrawn': 'retiré',
  'agreed fix': 'correction convenue',
  '{n}d past': '{n} j. de retard',
  '{n}d out': 'dans {n} j.',
  'no fix date agreed': 'aucune date de correction convenue',
  'the criterion this violates': 'le critère qu’il viole',
  'from': 'de',
  'raised by {who}': 'signalé par {who}',
  'Move to {state}': 'Passer à {state}',
  'Status': 'Statut',
  'Status of {ref}': 'Statut de {ref}',
  '{ref} moved to {state}': '{ref} passé à {state}',
  'Severity': 'Gravité',
  'Severity of {ref}': 'Gravité de {ref}',
  'Agreed fix': 'Correction convenue',
  'Agreed fix date on {ref}': 'Date de correction convenue sur {ref}',
  'Fix date on {ref} recorded': 'Date de correction sur {ref} enregistrée',
  'Not an AC violation after all — raise it as a change request instead': 'Finalement pas une violation d’un critère d’acceptation — signalez-le plutôt comme demande de modification',
  'To change request': 'En demande de modification',
  'Delete this defect — for a duplicate or a row raised by mistake': 'Supprimer ce défaut — pour un doublon ou une ligne signalée par erreur',
  'Delete': 'Supprimer',

  // ── the record zone ──────────────────────────────────────────────────────
  'Operator task': 'Tâche opérateur',
  'raised by the scheduler': 'créé par le Scheduler',
  'days ago. The control is the one at the top of the page.': 'jours. Le contrôle est celui en haut de la page.',
  'Deliverable coverage': 'Couverture des livrables',
  'G5 condition 2 — every deliverable must sit on an issued record': 'G5 condition 2 — chaque livrable doit figurer sur un procès-verbal émis',
  'No deliverable is defined': 'Aucun livrable défini',
  'G5 asks whether every deliverable sits on an issued acceptance record. With none defined there is nothing to cover, and the gate stays shut on its first condition.':
    'G5 demande si chaque livrable figure sur un procès-verbal d’acceptation émis. Sans aucun livrable défini, il n’y a rien à couvrir, et le gate reste fermé sur sa première condition.',
  'on {refs} ({status})': 'sur {refs} ({status})',
  'on no issued record — G5 cannot clear': 'sur aucun procès-verbal émis — G5 ne peut pas s’ouvrir',
  'issued': 'émis',
  'signed': 'signé',
  'deemed_notice_issued': 'acceptation tacite',
  'Acceptance records': 'Procès-verbaux d’acceptation',
  'record': 'procès-verbal',
  'records': 'procès-verbaux',
  'awaiting the sponsor': 'en attente du sponsor',
  'none composed': 'aucun établi',
  'No acceptance record has been composed': 'Aucun procès-verbal d’acceptation n’a été établi',
  'A record is generated from the register: the deliverables covered, every test result, every open defect with its agreed fix date, the severity definitions the client signed up to, and your exclusions. Composing one now would print':
    'Un procès-verbal est généré à partir du registre : les livrables couverts, chaque résultat de test, chaque défaut ouvert avec sa date de correction convenue, les définitions de gravité auxquelles le client a adhéré, et vos exclusions. En établir un maintenant imprimerait',
  "tests with no result — which is exactly what the composer's warnings would say.": 'des tests sans résultat — exactement ce que diraient les avertissements du générateur.',

  // ── one record ───────────────────────────────────────────────────────────
  'window closed': 'délai de vérification dépassé',
  'with the sponsor': 'chez le sponsor',
  'deemed notice': 'acceptation tacite',
  '— no milestone —': '— aucun jalon —',
  '{n}d overdue': '{n} j. de retard',
  '{n}d left': 'encore {n} j.',
  'window': 'délai',
  'closes': 'clôture',
  'The ball is': 'La balle est',
  'and has been for': 'et cela depuis',
  'days.': 'jours.',
  'The window closed': 'Le délai de vérification est dépassé depuis',
  'days ago and Signet raised a task rather than accepting anything.': 'jours, et Signet a créé une tâche plutôt que d’accepter quoi que ce soit.',
  'Nothing here needs you until it closes.': 'Rien ici n’a besoin de vous avant sa clôture.',
  'A draft: nothing has reached the client and no window is running. Issuing publishes it and starts the review clock.':
    'Un brouillon : rien n’a atteint le client, et aucun délai n’est en cours. L’émettre le publie et démarre le délai de vérification.',
  'Withdrawn — unpublished from the portal and kept on the record (P4).': 'Retiré — dépublié du portail et conservé dans les dossiers (P4).',
  'No review window is recorded on this record.': 'Aucun délai de vérification n’est enregistré sur ce procès-verbal.',
  'Deliverables covered': 'Livrables couverts',
  'none': 'aucun',
  'Published to the portal': 'Publié sur le portail',
  'yes': 'oui',
  'no': 'non',
  'Signature': 'Signature',
  '— unsigned': '— non signé',
  'Content hash': 'Hachage du contenu',
  'Read the record': 'Lire le procès-verbal',
  'Re-run the composer over the current test results and defect board, keeping this ref': 'Relancer le générateur sur les résultats de tests et le tableau des défauts actuels, en conservant cette référence',
  'Refresh': 'Actualiser',
  'Issue': 'Émettre',
  'Deemed notice': 'Acceptation tacite',
  'Discard draft': 'Abandonner le brouillon',
  'Withdraw': 'Retirer',

  // ── the composer ─────────────────────────────────────────────────────────
  'Compose an acceptance record': 'Établir un procès-verbal d’acceptation',
  'The document is generated from the register — it is not written by hand.': 'Le document est généré à partir du registre — il n’est pas rédigé à la main.',
  'These sentences will be printed in the document': 'Ces phrases seront imprimées dans le document',
  'Composing is still allowed — a record that states its own qualifications is the point. But the sponsor reads them.':
    'Établir le document reste autorisé — un procès-verbal qui énonce ses propres réserves, c’est précisément le but. Mais le sponsor les lit.',
  'The preview could not be rendered': 'L’aperçu n’a pas pu être généré',
  'The preview could not be rendered.': 'L’aperçu n’a pas pu être généré.',
  'Milestone': 'Jalon',
  'due {date}': 'échéance {date}',
  "Preview to pull in the milestone's deliverables.": 'Générer un aperçu pour charger les livrables du jalon.',
  'Exclusions and qualifications': 'Exclusions et réserves',
  'e.g. Excludes the OCR pipeline (DEL-04) — deferred to phase 2 by agreement of 21.05.2026.': 'p. ex. Exclut le pipeline OCR (DEL-04) — reporté à la phase 2 par accord du 21.05.2026.',
  'What the document will say': 'Ce que le document dira',
  'None selected.': 'Aucun sélectionné.',
  'Test results': 'Résultats des tests',
  'No test case is in scope.': 'Aucun cas de test dans le périmètre.',
  'Open defects': 'Défauts ouverts',
  'None.': 'Aucun.',
  'Severity definitions': 'Définitions de gravité',
  '{n} definition': '{n} définition',
  '{n} definitions': '{n} définitions',
  'the definitions did not load': 'les définitions n’ont pas été chargées',
  'not read': 'non lu',
  'Footer': 'Pied de page',
  'Signing accepts the deliverables listed above, subject to the open defects and their agreed fix dates.':
    'La signature vaut acceptation des livrables listés ci-dessus, sous réserve des défauts ouverts et de leurs dates de correction convenues.',
  'Draft only — nothing reaches the client until you issue it.': 'Simple brouillon — rien n’atteint le client tant que vous ne l’émettez pas.',
  'Re-read the register': 'Relire le registre',
  'Cancel': 'Annuler',
  'Create the draft': 'Établir le brouillon',
  'Create the draft anyway': 'Établir le brouillon quand même',

  // ── raise a defect ───────────────────────────────────────────────────────
  'Raise a defect': 'Signaler un défaut',
  'A defect must cite the acceptance criterion it violates. If nothing agreed was broken, it is a change request.':
    'Un défaut doit citer le critère d’acceptation qu’il viole. Si rien de convenu n’a été rompu, c’est une demande de modification.',
  'The criterion it violates — fixed by the failing run, not chosen from a list': 'Le critère qu’il viole — déterminé par l’exécution en échec, pas choisi dans une liste',
  'Title': 'Titre',
  'Description': 'Description',
  'What each severity commits you to': 'Ce à quoi chaque niveau de gravité vous oblige',
  'Agreed fix date': 'Date de correction convenue',
  'This is new scope → change request': 'Ceci est un nouveau périmètre → demande de modification',
  'A title of at least 5 characters is required — the server refuses less.': 'Un titre d’au moins 5 caractères est requis — le serveur refuse moins.',
  'Raise the defect': 'Signaler le défaut',

  // ── modals ───────────────────────────────────────────────────────────────
  'Acceptance record': 'Procès-verbal d’acceptation',
  'The artefact itself — the HTML that is hashed, stored and signed. It is deliberately not restyled here.':
    'L’artefact lui-même — le HTML qui est haché, stocké et signé. Il n’est délibérément pas restylé ici.',
  'Ready the plan for the client': 'Rendre le plan disponible pour le client',
  'This makes': 'Cela effectue',
  'write': 'écriture',
  'writes': 'écritures',
  "in one transaction. Every one is reversible from the Client Portal page; none of them touches the register's content.":
    'en une seule transaction. Chacune est réversible depuis la page «portail client» ; aucune ne touche au contenu du registre.',
  'Will write': 'Écrira',
  'Will not touch': 'Ne touchera pas',
  'engagements.portal_enabled and the invite: deciding who may see this engagement is a grant decision':
    'engagements.portal_enabled et l’invitation : décider qui peut voir ce mandat relève d’une décision d’autorisation',
  'nothing — whether a criterion is testable at all is a judgement, not a toggle': 'rien — la question de savoir si un critère est testable du tout relève d’un jugement, pas d’une bascule',
  "The client's view moves along two axes at once: marking a test case ready and publishing it both change what the portal's UAT list counts. Nothing that is still draft will be published.":
    'La vue du client évolue selon deux axes à la fois : marquer un cas de test comme prêt et le publier modifient tous deux ce que compte la liste UAT du portail. Rien de ce qui est encore à l’état de brouillon ne sera publié.',
  'Move': 'Passer',
  '{ref} is': '{ref} est',
  'and {severity}.': 'et {severity}.',
  'Moving it to': 'Le passer à',
  'takes it OFF the blocking count —': 'le retire du décompte des bloquants —',
  'may open as a result.': 'peut s’ouvrir de ce fait.',
  'does not clear': 'n’ouvre pas',
  '— only': '— seuls',
  'or': 'ou',
  'takes it off the blocking count.': 'le retirent du décompte des bloquants.',
  '{from} → {to} on {ref}': '{from} → {to} sur {ref}',
  'an audit row with the before and after': 'une ligne d’audit avec l’avant et l’après',
  'Change {ref} to {severity}': 'Passer {ref} à {severity}',
  'Change the severity': 'Changer la gravité',
  '{ref} is now {severity}': '{ref} est désormais {severity}',
  'Severity is a commitment, not a label.': 'La gravité est une obligation, pas une étiquette.',
  'counts': 'compte les défauts',
  'blocking and major': 'bloquants et majeurs',
  'defects that are not closed, verified or withdrawn — so': 'qui ne sont ni clos, ni vérifiés, ni retirés — donc',
  'CLOSES the gate that may be open now.': 'FERME le gate qui est peut-être ouvert actuellement.',
  'OPENS a gate this defect is currently holding shut.': 'OUVRE un gate que ce défaut maintient fermé actuellement.',
  'leaves the gate count unchanged.': 'laisse le décompte des gates inchangé.',
  'The definition the client signed up to is the wording in the record, not this dropdown.': 'La définition à laquelle le client a adhéré est le texte figurant dans le procès-verbal, pas ce menu déroulant.',
  'Record a witnessed run on {ref}': 'Enregistrer une exécution observée sur {ref}',
  'Record the run': 'Enregistrer l’exécution',
  'You watched this test run. The row is attributed to': 'Vous avez observé cette exécution de test. La ligne est attribuée à',
  'you‖dative': 'vous',
  'as an operator-witnessed run — the runs table renders': 'en tant qu’exécution observée par l’opérateur — le tableau des exécutions affiche',
  ', so it can never be mistaken for one the client executed. That distinction is the evidentiary value; it ends up inside a hashed record.':
    ', de sorte qu’elle ne puisse jamais être confondue avec une exécution effectuée par le client. Cette distinction est la valeur probante ; elle se retrouve dans un procès-verbal haché.',
  'What you observed': 'Ce que vous avez observé',
  'e.g. Walked section 4 with Asbjorn on 5 August; all six headings present.': 'p. ex. Section 4 parcourue avec Asbjorn le 5 août ; les six titres présents.',
  'Issue {ref}': 'Émettre {ref}',
  'Issue to the client': 'Émettre au client',
  'Issuing publishes the record to the portal and starts the review window. Leave the date empty to use':
    'L’émission publie le procès-verbal sur le portail et démarre le délai de vérification. Laissez la date vide pour utiliser le délai de vérification de',
  "'s review window of": '— soit',
  'Review deadline (optional)': 'Échéance de vérification (facultatif)',
  'On expiry Signet raises an operator task. It never accepts anything on its own.': 'À l’expiration, Signet crée une tâche opérateur. Il n’accepte jamais rien de sa propre initiative.',
  'Deemed-acceptance notice — {ref}': 'Avis d’acceptation tacite — {ref}',
  'Issue the notice': 'Émettre l’avis',
  'The review window closed': 'Le délai de vérification a expiré le',
  'with no signature. The notice is appended to the record and its hash re-computed; the sponsor can still counter-sign afterwards.':
    'sans signature. L’avis est ajouté au procès-verbal et son hachage recalculé ; le sponsor peut encore contresigner par la suite.',
  'the notice text into': 'le texte de l’avis dans',
  ', hash re-computed': ', hachage recalculé',
  'the milestone and its deliverables → accepted': 'le jalon et ses livrables → accepté',
  'the operator task closed': 'la tâche opérateur fermée',
  'Read this first': 'À lire en premier',
  'The document still lists': 'Le document liste encore',
  'open blocking or major defect': 'défaut ouvert bloquant ou majeur',
  'open blocking or major defects': 'défauts ouverts bloquants ou majeurs',
  'The notice says the deliverable is treated as accepted': 'L’avis indique que le livrable est considéré comme accepté',
  'subject to': 'sous réserve de',
  'that defect and its agreed fix date. If that is not the position you want on the record, close the defect first and recompose.':
    'ce défaut et de sa date de correction convenue. Si ce n’est pas la position que vous voulez voir figurer dans le procès-verbal, clôturez d’abord le défaut, puis recomposez.',
  'Note for the record (optional)': 'Note pour le procès-verbal (facultatif)',
  'e.g. Called the sponsor on 5 August; no objection raised.': 'p. ex. Sponsor appelé le 5 août ; aucune objection soulevée.',
  'Withdraw {ref}?': 'Retirer {ref} ?',
  'The record is unpublished from the portal and kept as': 'Le procès-verbal est dépublié du portail et conservé sous le statut',
  '— it is never deleted (P4). Use this when the facts moved after issue: withdraw, compose a fresh record, issue that.':
    '— il n’est jamais supprimé (P4). Utilisez ceci lorsque les faits ont changé après l’émission : retirez, établissez un nouveau procès-verbal, émettez-le.',
  'Discard draft {ref}?': 'Abandonner le brouillon {ref} ?',
  'Discard': 'Abandonner',
  'This draft was never issued, so the client has never seen it and nothing leaves the record. If it is only out of date,':
    'Ce brouillon n’a jamais été émis : le client ne l’a donc jamais vu, et rien ne quitte le procès-verbal. S’il est seulement obsolète,',
  'recomposes it against the current facts and keeps the ref.': 'le recompose à partir des faits actuels et conserve la référence.',
  'Convert {ref} to a change request': 'Convertir {ref} en demande de modification',
  'Convert': 'Convertir',
  'The defect is withdrawn (never deleted) with a link note, and a draft change request is created carrying its description. Use this when nothing agreed was actually broken.':
    'Le défaut est retiré (jamais supprimé) avec une note de liaison, et une demande de modification en brouillon est créée, reprenant sa description. Utilisez ceci lorsque rien de convenu n’a réellement été rompu.',
  'Triage note': 'Note de triage',
  'e.g. Column order was never in an acceptance criterion — this is new scope.': 'p. ex. L’ordre des colonnes n’a jamais figuré dans un critère d’acceptation — c’est un nouveau périmètre.',
  'Delete {ref}?': 'Supprimer {ref} ?',
  'Deleting…': 'Suppression…',
  'Delete permanently': 'Supprimer définitivement',
  'Immediate and permanent — this is for a defect that should never have been raised (a duplicate of the same failing run, a test row). If it was real and simply is not a defect after all, set it to':
    'Immédiat et définitif — ceci est réservé à un défaut qui n’aurait jamais dû être signalé (un doublon du même échec, une ligne de test). S’il était réel et n’est en réalité pas un défaut, réglez-le sur',
  'or convert it to a change request: both keep the triage decision on the record. The audit log keeps the deleted row.':
    'ou convertissez-le en demande de modification : les deux conservent la décision de triage dans le procès-verbal. Le journal d’audit conserve la ligne supprimée.',
  '{ref} cannot be deleted': '{ref} ne peut pas être supprimé',
  'Nothing else points at it — the row goes on its own.': 'Rien d’autre n’y fait référence — la ligne part seule.',
  'This also removes:': 'Cela supprime aussi :',
  'Understood': 'Compris',
  'Open the Client Portal page': 'Ouvrir la page «portail client»',
  'The portal is open and the plan is reachable:': 'Le portail est ouvert et le plan est accessible :',
  'test cases,': 'cas de test,',
  'published criteria and the defect form. The preview link itself is minted on the Client Portal page, which is where the grant it bypasses is administered.':
    'critères publiés et le formulaire de défaut. Le lien d’aperçu lui-même est généré sur la page «portail client», où l’autorisation qu’il contourne est administrée.',
  'The portal is': 'Le portail est',
  'on‖state': 'actif',
  'off': 'inactif',
  'for': 'pour',
  'and': 'et',
  'people are invited. A preview would show an empty shell — which is accurate, and is the point of step 1.':
    'personnes sont invitées. Un aperçu montrerait une coquille vide — ce qui est exact, et c’est le sens de l’étape 1.',

  // ── toasts ───────────────────────────────────────────────────────────────
  'Could not update the defect': 'Impossible de mettre à jour le défaut',
  'The batch could not be written': 'Le lot n’a pas pu être écrit',
  'Defect raised against {ref}': 'Défaut signalé contre {ref}',
  'Could not raise the defect': 'Impossible de signaler le défaut',
  'Could not record the run': 'Impossible d’enregistrer l’exécution',
  'Could not work out what deleting this defect would do': 'Impossible de déterminer l’effet de la suppression de ce défaut',
  '{ref} deleted': '{ref} supprimé',
  'Could not delete the defect': 'Impossible de supprimer le défaut',
  'Could not convert the defect': 'Impossible de convertir le défaut',
  '{ref} composed as a draft': '{ref} établi comme brouillon',
  'Could not compose the record': 'Impossible d’établir le procès-verbal',
  'Could not issue the record': 'Impossible d’émettre le procès-verbal',
  'Deemed-acceptance notice issued on {ref}': 'Avis d’acceptation tacite émis sur {ref}',
  'Could not issue the notice': 'Impossible d’émettre l’avis',
  'Could not recompose the record': 'Impossible de recomposer le procès-verbal',
  '{ref} withdrawn — unpublished from the portal': '{ref} retiré — dépublié du portail',
  'Could not withdraw the record': 'Impossible de retirer le procès-verbal',
  'Draft {ref} discarded': 'Brouillon {ref} abandonné',
  'Could not delete the draft': 'Impossible de supprimer le brouillon',
}, 'AcceptancePage');
